import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { filterMyCreations } from '../../Reducers/actions/creationsActions';
import './ProfileCreations.scss';
import { useNavigate } from 'react-router-dom';
import FilterBar from '../FilterBar/FilterBar';
import CreationCardV2 from './CreationCardV2';
import NoCreations from '../Icon/NoCreations';
import Skeleton from '../../containers/Library/ListingNewsSkeleton';

// const tabs = [
//     { id: 'all', label: 'All' },
//     { id: 'music', label: 'Music', icon: (color) => <Icon alias={'music'} width={16} color={color} /> },
//     { id: 'podcast', label: 'Podcast', icon: (color) => <Icon alias={'podcast'} width={16}  color={color}/> },
//     { id: 'artwork', label: 'Artwork', icon: (color) => <Icon alias={'artwork'} width={16}  color={color}/> }
// ];


const ProfileCreations = ({ firstLoad }) => {
    const {
        filteredCreations,
        loading,
        authUserId,
    } = useSelector(state => ({
        filteredCreations: filterMyCreations(state),
        loading: state.creation.loading,
        authUserId: state.auth?.user?.user_id ?? state.auth?.session?.user?.id,
    }));
    // const dispatch = useDispatch()
    const navigate = useNavigate()
    const [viewAll, setViewAll] = useState(false)
    // const handleChangeTab = (tab) => {
    //     dispatch(setActiveTab(tab))
    // }



    const handleViewCreation = (creation) => {
        const queryParams = new URLSearchParams(window.location.search);
        const ownerId = creation?.creator_id ?? creation?.users?.user_id;

        if (authUserId != null && ownerId != null && String(ownerId) === String(authUserId)) {
            queryParams.set('from_profile', 'true');
        }

        const queryString = queryParams.toString();
        navigate(`/creations/${creation.creation_id}${queryString ? `?${queryString}` : ''}`)
    }



    return (
        <div className='mycreations-container'>


            {
                (filteredCreations?.length > 0) ? (
                    <div className='gap-8 creations-wrapper'>
                        {filteredCreations.slice(0, viewAll ? filteredCreations.length : 6).map(creation => (
                            <CreationCardV2 key={creation.creation_id} creation={creation} handleViewCreation={handleViewCreation} />
                        ))}
                    </div>
                ) : (loading || !firstLoad) ? <div className='gap-8 creations-wrapper'>
                    {[1, 2, 3, 4].map(creation => (
                        <Skeleton key={creation} width='175px' height='140px' />
                    ))}
                </div> : (

                    <div className="profile-creations-empty-state" onClick={() => navigate('/creations/add')}>
                        <NoCreations />
                        <p className='fg-dark fs-sm2 fw-bold mt-24'>Publish your first creation</p>
                    </div>
                )}
            {!viewAll && filteredCreations?.length > 6 && <div className='d-flex aic jcc w-full'>
                <button className="btn red-outline-btn btn-sm fs-tiny mt-24" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setViewAll(true)
                }}
                >VIEW ALL</button>
            </div>}
        </div>
    )
};

export default ProfileCreations;